<template>
  <div
    style="display: flex; flex-direction: column; height: calc(100vh - 180px)"
  >
    <div style="display: flex; flex-wrap: wrap">
      <div class="condition-item">
        <label class="fn-14">选择时间</label>
        <el-date-picker
          v-model="searchObj.stime"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
        <label class="fn-14" style="padding-left: 10px">-</label>
        <el-date-picker
          v-model="searchObj.etime"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
      </div>
      <div class="condition-item">
        <el-button type="success" icon="el-icon-upload2" size="small"
          >上传云盘数据</el-button
        >
        <el-button type="primary" icon="el-icon-search" size="small"
          >查询</el-button
        >
      </div>
    </div>
    <div style="margin-bottom: 15px; flex: 1; overflow: hidden">
      <el-table
        :data="taskList"
        v-loading="tableLoading"
        stripe
        border
        height="100%"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <template #empty>
          <p>{{ tableLoading == true ? "数据加载中" : "暂无数据" }}</p>
        </template>
        <el-table-column prop="orderNo" label="月份"></el-table-column>
        <el-table-column prop="orderNo" label="授权开通量"></el-table-column>
        <el-table-column
          prop="orderNo"
          label="用户登录云盘量"
        ></el-table-column>
        <el-table-column
          prop="orderNo"
          label="云盘用户活跃量(近一个月)"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "photoSyncYpLoginList",
  data() {
    return {
      tableLoading: false,
      taskList: [],
      searchObj: {
        stime: "",
        etime: "",
      },
    };
  },
};
</script>
